<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.product_categories">
  <app-popup-header title="{{localService.languageContent.product_categories.header}}"></app-popup-header>
  <div class="modal-body modal-body-no-flexible-height">
    <app-language-container [MaxLength]="50" [(languageContents)]="languageContents" (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)" [IsShowAllLanguages]="true" [isModeChangeAllowed]="false" [IsPartiallyMandatory]="true" [id]="elementIds.name"></app-language-container>
  </div>
  <div class="modal-footer modal_footer_message" *ngIf="message != ''">
    <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>
